import * as React from "react";
import { useHistory } from "react-router";

import { DesignToken, Link } from "@livechat/design-system-react-components";

import Text from "components/layout/Text";
import { withVar } from "themes/helpers";

const SubscriptionPastDueAlert: React.FC = () => {
  const history = useHistory();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleUpdateBilling = () => {
    history.push("/subscription/account-details");
  };

  return (
    <Text
      fontSize="16px"
      fontWeight="400"
      color={withVar(DesignToken.ActionNegativeDefault)}
      textAlign="center"
      paddingBottom="10px"
    >
      Payment needed to keep your account active.{" "}
      <Link color={withVar(DesignToken.ActionPrimaryDefault)} onClick={handleUpdateBilling} bold={false}>
        Update billing details
      </Link>
    </Text>
  );
};

export default SubscriptionPastDueAlert;
